// WidgetTree.js
import React from 'react';
import { renderIntoDocument } from 'react-dom/test-utils';
import { Tree, CheckTree, Input } from 'rsuite';

import 'rsuite/dist/styles/rsuite-default.css';
import '../css/widget/widget.tree.css'

class WidgetTree extends React.Component
{ 
    constructor(props)
    {
        super( props );

        this.state = {
            word : "",
            options : props.options,
            treeData : props.data,
            allData : props.data,
            isFromState : false,
            defaultValue : []
        }

        this.findNode = this.findNode.bind(this);
        this.findData = this.findData.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.findChildNodes = this.findChildNodes.bind(this);
        this.findParentNodes = this.findParentNodes.bind(this);
    }

    

    /**
     * 搜索属性结构符合要求的数据
     * @param {*} value 搜索输入的关键字
     */
    onInputChange( value )
    {
        let data = this.findData(value, this.props.data); 

        this.setState({ treeData:data, isFromState:true});
    }

    /**
     * 查询符合条件的数据
     * @param {*} word 筛选关键字
     * @param {*} soureData 原始数据
     * @returns 
     */
    findData( word, soureData )
    {
        let data = [];

        for( var i in soureData )
        {
            let children = undefined;

            if( soureData[i].children!==undefined && soureData[i].children.length>0 )
            {
                children = this.findData(word, soureData[i].children);
            }

            if( children!==undefined && children.length>0 )
            {
                let item = { ...soureData[i] };
                item["children"] = children;
                data.push(item);
            }
            else
            {
                if( soureData[i].label.indexOf(word)!==-1 )
                {
                    let item = { ...soureData[i] };
                    item["children"] = undefined;
                    data.push(item);
                }
            }
        }

        return data;
    }
 
    /**
     * 选择值
     * @param {*} values 选中的值
     * @param {*} item 选中的数据项
     * @param {*} event 选中的事件
     */
    onSelect(item, values)
    {
        let { options,isFromState } = this.state;

        const { data } = this.props;
        let defaultValue=[], ret = [], nodeMap = {}, nodes = [], arr = [];

        if( options.type==="check")
        {
            let add = values

            arr.push(item.name);

            if ( item.children!==undefined) 
            {
                for(let items of item.children)
                {
                    arr.push(items.name);

                    if(items.children !== undefined)
                    {
                        for(let ite of items.children)
                        {
                            arr.push(ite.name);
                        }
                    }
                }

                let acc = add.concat(arr)

                defaultValue.push(...acc);
            }
            else 
            {   
                //本来的样子
                defaultValue.push(...values);
            }
           
        }
        else
        {
            defaultValue.push(values);
        }

        defaultValue = Array.from(new Set(defaultValue));

        if( item.check===false )
        {
            for( let item of arr )
            {
                for( let i=0 ; i<defaultValue.length; i++ )
                {
                    if(item===defaultValue[i] )
                    {
                        defaultValue.splice(i, 1);
                        break;
                    }
                }
            }
        }

        for( let value of defaultValue )
        {
            let node = this.findNode(data, value);
            
            if( options.cascade!==undefined && options.cascade===false )
            {
                if( options.cascadeDown!==undefined && options.cascadeDown==true )
                {
                    this.findChildNodes(node, nodes, nodeMap);
                }
                else if( options.cascadeUp!==undefined && options.cascadeUp==true )
                {
                    this.findParentNodes(node, nodes, nodeMap);
                }
                else
                {
                    nodes.push(node);
                }
            }
            else
            {
                this.findParentNodes(node, nodes, nodeMap);
                this.findChildNodes(node, nodes, nodeMap);
            }
        }

        if( nodes!==undefined && nodes.length>0 )
        {
            defaultValue = [];

            for( let node of nodes )
            {
                defaultValue.push( node.value );
            }
        }

        this.setState({"defaultValue":defaultValue, isFromState:true});

        if( this.props.onSelect!==undefined )
        {
            this.props.onSelect(nodes);
        }
    }

    findNode( data, value)
    {
        if( data!==undefined && data.length>0 )
        {
            for( let node of data)
            {
                let retNode = null;
                
                if( node.value===value )
                {
                    retNode = node;
                }
                else
                {
                    if( node.children!==undefined )
                    {
                        retNode = this.findNode(node.children, value);
                    }
                }

                if( retNode!==undefined && retNode!==null )
                {
                    return retNode;
                }
            }
        }
    }

    findParentNodes( item, nodes, nodeMap )
    {
        if( item.parent!==undefined && item.parent!==-1 )
        {
            this.findParentNodes(item.parent, nodes, nodeMap)
        }

        if( nodeMap[item.value]===undefined || nodeMap[item.value]===null)
        {
            nodes.push(item);
            nodeMap[item.value] = item;
        }
        
        
    }

    findChildNodes( item, nodes, nodeMap)
    {
        if( nodeMap[item.value]===undefined || nodeMap[item.value]===null )
        {
            nodes.push(item);
            nodeMap[item.value] = item;
        }
       
        if( item.children!==undefined && item.children.length>0 )
        {
            for( let child of item.children)
            {
                this.findChildNodes(child, nodes, nodeMap)
            }
        }
    }

    render()
    {
        let { data } = this.props;

        let { options, defaultValue, isFromState, treeData } = this.state;

        let cascade = (options!==undefined && options.cascade!==undefined ? options.cascade : true);

        if( !isFromState )
        {
            treeData = data;

            this.state["treeData"] = data;
        }

        if( this.props.defaultValue!==undefined && !isFromState )
        {
            defaultValue = this.props.defaultValue;

            this.state["defaultValue"] = defaultValue;
        }

        this.state["isFromState"] = false;

        if( options.type==="check")
        {
            return (
                <div className="widget-tree">
                    <div className="tree-input">
                        <Input style={{ width:'80%' }} placeholder="请输入关键字" onChange={this.onInputChange} />
                    </div>
                    <div className="tree-frame">
                        <CheckTree className='tree' data={treeData} onSelect={this.onSelect} cascade={cascade}
                            defaultExpandAll={ (options!==undefined && options.defaultExpandAll!==undefined) ? options.defaultExpandAll : true} 
                            defaultValue = {defaultValue}
                            value = {defaultValue}
                            />
                    </div>
                </div>
            );
        }
        else
        {
            let value = defaultValue[0];

            return (
                <div className="widget-tree">
                    <div className="tree-input">
                        <Input style={{ width:'80%' }} placeholder="请输入关键字" onChange={this.onInputChange} />
                    </div>
                    <div className="tree-frame">
                        <Tree className='tree' data={treeData} onSelect={this.onSelect}
                            defaultValue = { value }
                            value = { value }
                            />
                    </div>
                </div>
            );
        }
        
    }
}

export default WidgetTree
